import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => {
  const { marginLR, paddingLR } = theme.mixins;

  return {
    EventsTabsFilter: {
      display: 'flex',
      flexDirection: 'column',
      gap: pxToRem(48),
      padding: '0 ' + pxToRem(92),
      padding: pxToRem(96) + ' 5.75% 0',
      overflowX: 'hidden',

      [theme.breakpoints.down('md')]: {
        padding: pxToRem(40) + ' ' + pxToRem(24) + ' 0',
        gap: pxToRem(32),
      },

      '& .eventsTitle': {
        fontFamily: theme.custom.fontFamily.primaryBold,
        color: theme.palette.common.black,
        fontStyle: "normal",
        fontWeight: '400',
        lineHeight: pxToRem(40),

        '@media (max-width: 768px)': {
          fontSize: pxToRem(26),
          lineHeight: pxToRem(32),
        },
        '@media (max-width: 375px)': {
          fontSize: pxToRem(22),
        },
      },

      '& .eventsCTA': {
        fontSize: pxToRem(22),

        '&.mobile': {
          display: 'none',
        },

        '& .MuiButton-endIcon': {
          ...theme.mixins.marginLeft(22),
        },

        '&:hover': {
          '& .MuiButton-label': {
            textDecoration: 'underline',
          },
        },

        [theme.breakpoints.down('md')]: {
          fontSize: pxToRem(16),
          '& .MuiButton-endIcon': {
            ...theme.mixins.marginLeft(16),
          },

          '&.desktop': {
            display: 'none',
          },

          '&.mobile': {
            display: 'inline-flex',
            marginTop: pxToRem(6),
            marginBottom: pxToRem(16),
          },
        },

        '& .btn-txt': {
          fontFamily: theme.custom.fontFamily.primaryBold,
          fontWeight: '400',
        }
      },

      '& .filterableEventsHeader': {
        display: 'flex',
        flexDirection: 'column',
        gap: pxToRem(24),

        [theme.breakpoints.down('md')]: {
          gap: pxToRem(0),
        },

        '& .filters-and-cta-container': {
          display: 'flex',
          justifyContent: 'space-between',

          [theme.breakpoints.down('md')]: {
            ...theme.mixins.marginRight(pxToRem(-15)),
          },

          '& .filtersWrapper': {
            display: 'flex',
            gap: pxToRem(8),

            [theme.breakpoints.down('md')]: {
              marginTop: pxToRem(12),
              gap: '0.4rem',
              width: '100%',
              overflow: 'scroll',
            },

            '& .filterBtn': {
              height: pxToRem(40),
              padding: `${pxToRem(12)} ${pxToRem(16)}`,
              borderRadius: pxToRem(100),
              backgroundColor: 'transparent',
              boxShadow: 'none',
              transition: 'all 0.3s ease-in-out',
              '& .MuiButton-label': {
                width: 'max-content'
              },
              [theme.breakpoints.down('md')]: {
                height: pxToRem(32),
                padding: `${pxToRem(8)} ${pxToRem(16)}`,
              },

              '& .btn-txt': {
                display: 'flex',
                alignItems: 'center',
                gap: pxToRem(8),
                color: '#009086',
                fontSize: pxToRem(12),
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: pxToRem(16),
                letterSpacing: theme.isDirectionRtl ? '0' : '0.5px',
                textTransform: "uppercase",
                transition: 'all 0.3s ease-in-out',
                width: 'max-content',
                '@media (max-width: 400px)': {
                  gap: pxToRem(4),
                },
              },

              '& svg': {
                width: pxToRem(12),
                height: pxToRem(12),
                display: 'none',

                '@media (max-width: 400px)': {
                  width: pxToRem(11),
                  height: pxToRem(11),
                },

                '@media (max-width: 375px)': {
                  width: pxToRem(9),
                  height: pxToRem(9),
                },
              },

              '&.active': {
                backgroundColor: '#009086',
                '& .btn-txt': {
                  color: theme.palette.common.white,
                },
              },

            },
          },
        },
      },
    },
  };
});

export default useStyles;
